import { Component, Input } from '@angular/core';
import { CustomState as IWorkflowItemCustomStateTemplate } from '@interfaces/interfaces';

export type TWfsStatus='signiert'|'abgenommen'|'offene query'| 'bearbeitete query'|
	'in bearbeitung'|'eingabe vollständig'|'nicht begonnen'|'nicht verfügbar';

type State = Partial<Omit<IWorkflowItemCustomStateTemplate, 'id'> & {disabled?: true;}>;

@Component({
	selector: 'app-buttons-wfs-status',
	templateUrl: './buttons-wfs-status.component.html',
	styleUrls: ['buttons-wfs-status.component.scss']
})
export class ButtonsWfsStatusComponent{
	private fallbackTemplate: State = {
		symbol: 'insurance',
		color: '#ff0000',
		colorShouldBeBackground: false,
		label: 'Fallback Tooltip',
	};
	public activeTemplate: State;

	@Input()
	set status(status:TWfsStatus){ this.updateStatus(status);}

	private buttons: Record<TWfsStatus, State> = {
		signiert:{
			symbol: 'safety-certificate',
			color: '#208000',
			colorShouldBeBackground: true,
		},
		abgenommen:{
			symbol: 'like',
			color: '#208000',
			colorShouldBeBackground: true,
			label: 'Ein Label im Tooltip',
		},
		'offene query':{
			symbol: 'alert',
			color: '#b60000',
			colorShouldBeBackground: true,
		},
		'bearbeitete query':{
			symbol: 'comment',
			color: '#b60000',
			colorShouldBeBackground: true,
		},
		'in bearbeitung':{
			symbol: 'play-circle',
			color: '#ffe000',
			colorShouldBeBackground: true,
		},
		'eingabe vollständig':{
			symbol: 'check-circle',
			color: '#208000',
			colorShouldBeBackground: true,
		},
		'nicht begonnen':{
			symbol: 'play-circle',
			color: '#7a7a7a',
			colorShouldBeBackground: false,
		},
		'nicht verfügbar':{
			symbol: 'stop',
			color: '#7a7a7a',
			colorShouldBeBackground: true,
			disabled: true
		}
	};

	private updateStatus(status:TWfsStatus):void {
		this.activeTemplate = this.buttons[status] || this.fallbackTemplate;
	}
}

